// extracted by mini-css-extract-plugin
export default {"links":"AboutPage_links__BXSa4","footer":"AboutPage_footer__nmYdn"};